<template>
  <div class="checkTable">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      <div class="headTxt">查询管网巡查情况记录</div>
    </div>
    <el-form ref="dataForm" class="searchForm" :model="dataForm">
      <el-form-item>
<!--        <el-date-picker-->
<!--          v-model="dataForm.startDate"-->
<!--          type="date"-->
<!--          class="fullList"-->
<!--          placeholder="请选择开始时间"-->
<!--          format="yyyy-MM-dd"-->
<!--          value-format="yyyy-MM-dd"-->
<!--        />-->
<!--        <el-date-picker-->
<!--          v-model="dataForm.endDate"-->
<!--          type="date"-->
<!--          class="fullList"-->
<!--          placeholder="请选择结束时间"-->
<!--          format="yyyy-MM-dd"-->
<!--          value-format="yyyy-MM-dd"-->
<!--        />-->
        <el-button type="primary" class="fullList" @click="getDataList(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      lazy
      v-loading="dataListLoading"
      height="calc(100vh - 150px - 40px)"
      style="width: 100%"
      ref="scrollTable"
    >
      <el-table-column
        prop="date"
        header-align="center"
        align="center"
        width="100"
        fixed="left"
        label="日期"
      />
      <el-table-column
        prop="userlist"
        header-align="center"
        align="center"
        width="170"
        label="巡查人员"
      />
      <el-table-column
        prop="weather"
        header-align="center"
        align="center"
        label="天气"
      />
      <el-table-column
        prop="confirmTime"
        header-align="center"
        align="center"
        label="确认时间"
      />
      <el-table-column
        prop="managerCheckTime"
        header-align="center"
        align="center"
        label="经理检查时间"
      />
      <el-table-column
        prop="monitorCheckTime"
        header-align="center"
        align="center"
        label="维修检查时间"
      />
      <el-table-column
        header-align="center"
        align="center"
        label="操作"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            @click="$router.push({ name:'inspectionRecord', query: {id: scope.row.id} })"
            type="text"
            size="mini"
          >查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :pager-count="5"
      :total="totalPage"
      style="margin: 15px 0;text-align: center"
      layout="prev, pager, next"
    />
  </div>
</template>

<script>
import moment from "moment"
export default {
  data () {
    return {
      popstateLock: 0, //是否监听物理返回键
      dataForm: {
        startDate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
      },
      pageCount: 5,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataList: [], // 数据列表
      dataListLoading: false, // 数据加载
      loading: true
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate();
      }else{
        this.removePopstate();
      }
    }
  },
  created() {
    this.getDataList(1);
  },
  mounted () {
    this.addPopstate(); //在导航栏挂载的时候，对物理返回键进行监听
    // this.scrollLoad();
  },
  destroyed(){
    this.removePopstate();
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 后面获取数据列表
    async getDataList(type) {
      this.dataListLoading = true;
      // if (this.dataForm.startDate === null || this.dataForm.startDate === '') {
      //   this.dataForm.startDate = moment(new Date()).startOf("month").format("YYYY-MM-DD")
      // }
      // if (this.dataForm.endDate === null || this.dataForm.endDate === '') {
      //   this.dataForm.endDate = moment(new Date()).format("YYYY-MM-DD")
      // }
      if (type === 1) {
        this.pageIndex = 1;
        this.dataList = [];
      }
      // if (moment(this.dataForm.endDate).isBefore(this.dataForm.startDate) == false) {
        // 根据获取的数据请求符合条件的工单
        await this.$http.httpGet('/app/appTbInspectionRecord/list', {
          // startDateTime: this.dataForm.startDate + " 00:00:00",
          // endDateTime: this.dataForm.endDate + " 23:59:59",
          page: this.pageIndex,
          limit: this.pageSize
        }).then(res => {
          if (res.code === 0 && res.msg === 'success') {
            this.dataList = res.page.list;
            this.totalPage = res.page.totalCount;
            this.dataListLoading = false;
          } else {
            this.$message.error('获取数据失败: ' + res.msg);
            this.totalPage = 0;
            this.dataList = [];
            this.dataListLoading = false;
          }
        }).catch(() => {
          this.dataListLoading = false;
        })
      // } else {
      //   this.$message.error("结束时间必须大于开始时间");
      //   this.dataListLoading = false;
      // }
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    scrollLoad() {
      // 获取表格对象
      let dom = document.querySelector(".el-table__body-wrapper");
      dom.addEventListener("touchmove", (v) => {
        const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
        // 判断是否到底，可以加载下一页
        if (scrollDistance <= 0) {
        //   // 判断是否全部加载完成
          if (this.totalPage > this.pageIndex) {
        //     this.$message.warning("已经见底了 ～");
        //   } else {
        //     // 加载下一页方法
            this.loadMore();
          }
        }
      });
    },
    // 加载更多
    async loadMore() {
      if (this.totalPage > this.pageIndex) {
        this.pageIndex = this.pageIndex + 1;
        // 根据获取的数据请求符合条件的工单
        await this.$http.httpGet('/app/appTbInspectionRecord/list', {
          // startDateTime: this.dataForm.startDate + " 00:00:00",
          // endDateTime: this.dataForm.endDate + " 23:59:59",
          page: this.pageIndex,
          limit: this.pageSize
        }).then(res => {
          if (res && res.code === 0) {
            this.dataList = this.dataList.concat(res.page.list);
            this.totalPage = res.page.totalPage;
          } else {
            this.dataList = this.dataList;
            this.totalPage = 0;
            this.$message.error('获取数据失败: ' + res.msg)
          }
        }).catch(() => {
        })
      }
    },
    // 返回首页
    backIndex() {
      this.$router.replace({ name: 'Index' });
    }
  },

}
</script>

<style lang="scss">
.checkTable {
  position: relative;
  padding: 60px 10px 0;
  .headLine {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 600;
    background-color: #409eff;
    color: #fff;
    text-align: center;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .headTxt {
      font-size: 16px;
      line-height: 50px;
    }
  }
  .searchForm {
    position: relative;
    .el-form-item {
      margin: 0 0 10px;
      position: relative;
      overflow: hidden;
      .el-form-item__content {
        .fullList {
          width: 100% !important;
          margin: 0 0 10px;
        }
        .el-select {
          width: 75%;
          float: left;
        }
        .el-button {
          width: 22%;
          float: right;
        }
      }
    }
  }
}
</style>
